import { clsx } from 'clsx';
import { type FC } from 'react';

import { type PublisherCardLayoutContainerProps } from '../../types';

import styles from './PublisherCardLayout.css';

export const PublisherCardLayout: FC<PublisherCardLayoutContainerProps> = props => {
  const { brandingLevel, avatar, type, documentsChecked, nameWithBadges, contactActions } = props;

  return (
    <div className={clsx(styles['container'], brandingLevel === 'thirdLevel' && styles['container--platinum'])}>
      <div className={styles['avatar-wrapper']}>{avatar}</div>
      <div className={styles['info-container']}>
        <div data-testid="publisher.type">{type}</div>
        <div data-testid="publisher.name">{nameWithBadges}</div>
        <div className={styles['documents-checked-wrapper']}>{documentsChecked}</div>
      </div>
      <div className={styles['contact-actions-layout-wrapper']}>{contactActions}</div>
    </div>
  );
};
